import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import api from "@/lib/api";
import { RankPill } from "./Dashboard";

export default function RankTracker() {
  const { activeBiz } = useOutletContext();
  const [ranks, setRanks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!activeBiz) { setLoading(false); return; }
    (async () => {
      setLoading(true);
      try {
        const { data } = await api.get(`/businesses/${activeBiz.id}/ranks`);
        setRanks(data.ranks || []);
      } catch {}
      setLoading(false);
    })();
  }, [activeBiz]);

  if (!activeBiz) return <Empty msg="Add a business first." />;

  return (
    <div className="p-6 lg:p-10 space-y-6 max-w-7xl">
      <header>
        <div className="label-tiny mb-1">Tracking</div>
        <h1 className="font-display text-4xl font-black tracking-tighter" data-testid="ranktracker-title">Rank Tracker</h1>
        <p className="text-zinc-500 mt-1">15-day history per keyword. Lower is better.</p>
      </header>

      {loading ? (
        <div className="py-16 flex justify-center"><span className="spinner text-zinc-400"></span></div>
      ) : ranks.length === 0 ? (
        <Empty msg="No keywords yet. Add some in Settings." />
      ) : (
        <div className="bento p-0 overflow-hidden">
          <table className="w-full">
            <thead>
              <tr className="bg-zinc-50 border-b border-zinc-200">
                <th className="label-tiny p-4 text-left">Keyword</th>
                <th className="label-tiny p-4 text-left">Search Vol</th>
                <th className="label-tiny p-4 text-left">Current Rank</th>
                <th className="label-tiny p-4 text-left">15-Day Trend</th>
                <th className="label-tiny p-4 text-left">Status</th>
              </tr>
            </thead>
            <tbody>
              {ranks.map((r) => (
                <tr key={r.keyword} className="border-b border-zinc-100 hover:bg-zinc-50" data-testid={`row-${r.keyword}`}>
                  <td className="p-4 font-medium">{r.keyword}</td>
                  <td className="p-4 font-mono text-xs text-zinc-600">{r.search_volume.toLocaleString()}</td>
                  <td className="p-4"><RankPill rank={r.rank} /></td>
                  <td className="p-4">
                    <div className="flex items-end gap-px h-10 w-32">
                      {r.history.map((h, i) => (
                        <div key={i} className="flex-1 bg-[#002FA7]" style={{ height: `${((21 - h.rank) / 20) * 100}%` }} title={`Day ${h.day}: #${h.rank}`}></div>
                      ))}
                    </div>
                  </td>
                  <td className="p-4 font-mono text-xs">
                    {r.in_top_3 ? <span className="text-[#22C55E]">▲ TOP 3</span> : r.in_top_10 ? <span className="text-[#EAB308]">TOP 10</span> : <span className="text-[#EF4444]">PUSH HARDER</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

function Empty({ msg }) {
  return <div className="p-12 text-zinc-500 max-w-3xl">{msg}</div>;
}
